<!-- program 模板列表 -->
<template>
  <div class="ProgramTemplateList">
    <!-- 项目模板 -->
    <div class="ProgramTemplateTop">
      <div class="searchTitle">
        <i
          class="iconfont icon-search pointer"
          @click="goToLogin('welcomeTemplateSearch')"
          :title="$t('lang.search')"></i>
        <i
          class="iconfont icon-add pointer"
          @click="goToLogin('welcomeTemplateAdd')"
          :title="$t('lang.addfile')"></i>
      </div>
      <!-- 搜索框 -->
      <div
        class="searchInput"
        v-if="fileInput">
        <el-input
          v-model="PTemplateListParam.condition"
          :placeholder="$t('lang.fileName')"
          class="SearchInput"
          @change="getProgramList(false)"></el-input>
        <i
          class="iconfont icon-search pointer"
          @click="getProgramList(false)"></i>
      </div>
    </div>
    <div
      class="PTemplateListWrap"
      v-scroll="bindPTemplateScroll">
      <ul class="draggable_box PTemplateItem">
        <li
          :class="['draggable_item', 'TemplateFile', {'pitchOnItem': PitchTemplate == item.id}]"
          @click="getCheck(item)"
          v-for="(item, index) in programTemplateList"
          :key="index"
          draggable="true"
          :data-target="'source' + index"
          :data-programtemplate="'programtemplate'"
          :data-device="JSON.stringify(item)">
          <div class="templateName"> {{ item.templateName }}</div>
          <div class="icon">
            <i
              class="el-icon-edit-outline"
              @click.stop="editTemplate(item)"></i>
            <i
              class="el-icon-delete"
              @click="deleteTemplate(item)"></i>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import Bus from '@/assets/js/vueBus.js'
import toTips from '@/assets/js/toTipsObj'
import { creatAccount } from '@/assets/js/common/creatAccount.js'
import { playoutAnalyze } from '@/assets/js/googleAnalyze/playout.js'
export default {
  data () {
    return {
      // 模板文件搜素
      fileInput: false,
      // 模板列表
      programTemplateList: [],
      // 选中模板
      PitchTemplate: '',
      // PTemplate绑定滚动事件
      bindPTemplateScroll: {
        onScroll: this.bindPTemplateScrollHandle,
        distance: 10,
        directive: '.PTemplateItem'
      },
      // template是否有下一页
      PTemplateHasnextpage: false,
      // template分页查询信息
      PTemplateListParam: {
        pageNum: 1,
        pageSize: 20,
        condition: '',
        spliceType: '',
        startTime: '',
        endTime: ''
      }
    }
  },
  created () {
  },
  mounted () {
  },
  methods: {
    goToLogin (tag) {
      creatAccount()
      playoutAnalyze(tag)
    },
    searchShow () {
      this.fileInput = !this.fileInput
      this.PTemplateListParam.condition = ''
      if (!this.fileInput) {
        this.getProgramList(false)
      }
    },
    // 添加模板
    addProgram () {
      this.$emit('editTemplate', {
        status: true,
        name: 'programTemplate'
      })
      Bus.$emit('goTemplateBlank', {
        tag: 'tem',
        type: 'add'
      }, false)
    },
    // 编辑模板
    editTemplate (item) {
      this.PitchTemplate = item.id
      this.$emit('editTemplate', {
        status: true,
        name: 'programTemplate',
        data: item
      })
      this.$nextTick(() => {
        Bus.$emit('goTemplateBlank', {
          data: item,
          tag: 'tem',
          type: 'edit'
        }, true)
      })
    },
    // 删除模板
    deleteTemplate (item) {
      const Url = '/gatewayPlayoutUrl/tvu-playout/eventTemplate/delete'
      const params = {
        ids: [item.id]
      }
      this.axios.post(Url, params, { contentType: 'application/json;charset=UTF-8' }).then((res) => {
        if (res.data.errorCode == '0x0') {
          this.$message.success(this.$t('lang.deleteSuccess'))
          this.getProgramList(false)
        } else {
          this.$message.info(this.$t('lang.fileUsed'))
        }
      })
    },
    // 点击source发生事情
    getCheck (data) {
      if (this.PitchTemplate == data.id) {
        this.PitchTemplate = ''
      } else {
        this.PitchTemplate = data.id
      }
    },
    // PTemplate绑定滚动加载
    bindPTemplateScrollHandle () {
      if (this.PTemplateHasnextpage) {
        this.PTemplateListParam.pageNum++
        this.getProgramList(true)
      }
    },
    // 获取paogram模板列表
    getProgramList (queryType) {
      if (!queryType) {
        this.PTemplateListParam.pageNum = 1
      }
      this.axios
        .post(
          '/gatewayPlayoutUrl/tvu-playout/eventTemplate/page',
          this.PTemplateListParam
        )
        .then((res) => {
          if (res.status == 200) {
            if (res.data.errorCode == '0x0') {
              this.PTemplateHasnextpage = res.data.result.hasNextPage
              if (queryType) {
                this.programTemplateList.push(...res.data.result.list)
              } else {
                this.programTemplateList = res.data.result.list
              }
              Bus.$emit('leftListUpdate')
            } else {
              const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
              this.$message.info(errorInfo)
            }
          }
        })
    }
  }
}
</script>

<style scoped lang="less">
.ProgramTemplateList {
  .ProgramTemplateTop {
    .searchTitle {
      padding: 12px 0 10px 0;
      border-bottom: 2px solid #555;
      text-align: right;
      i {
        margin: 0 4px;
        color: #cccccc;
      }
    }
    .searchInput {
      position: relative;
      i {
        position: absolute;
        right: 12px;
        font-size: 20px;
        top: 7px;
        z-index: 1001;
      }
    }
  }
  .PTemplateListWrap {
    .PTemplateItem {
      height: 470px;
      overflow-y: auto;
      display: flex;
      flex-wrap: wrap;
      align-content: flex-start;
      padding-top: 8px;
      margin: 0;
      .TemplateFile {
        width: 336px;
        height: 28px;
        background: #444444;
        box-sizing: border-box;
        padding: 0 0 0 8px;
        font-size: 12px;
        color: #cccccc;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .templateName{
          width: 240px;
          text-align: left;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          line-height: 28px;
        }
        .icon{
          display: none;
          i{
            font-size: 16px;
            margin-right: 12px;
          }
        }
      }
      .TemplateFile:hover .icon{
        display: block;
      }
      .pitchOnItem {
        background: #3f5d46;
      }
    }
  }
}
</style>
